import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components';

import PageHeader from '../../Reusable/PageHeader';
import { FlexColumn, Flex } from '../../Reusable/Container';
import { apiPOSTReq } from '../../../Utils/api';
import environment from '../../../environment';
import { Modal, Select, Skeleton, Spin } from 'antd';
import TableView from '../../Reusable/TableView';
import { LoadingOutlined } from '@ant-design/icons';
import { LabeledInput } from '../../Reusable/Input';
import Search from '../../../Images/search.png'
import { ErrorAlert } from '../../Reusable/Alert';
class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalVisible: false,
            currentRow: null,
            editableFeatureValue: "",
            loadingSkeleton: false
        }
    }

    componentDidMount = () => {
        this.fetchBusinessFeatures()
    }

    fetchBusinessFeatures = () => {
        var { UserInfo, BusinessUniqueKey } = this.props.aionStore
        var { Email } = UserInfo;
        const { searchTerm, featureMap } = this.state
        var oldFeaturesList = featureMap;

        var body = {
            UserId: Email,
            SearchStr: searchTerm
        }

        if(searchTerm){
            this.setState({ loadingSkeleton: true })
        }
        apiPOSTReq(`${environment.uamBaseUrl}/getBusinessFeatures`, {}, body, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp || {};
                if (data.result) {
                    var { businessFeatureMap } = data || {};
                    this.setState({ featureMap: businessFeatureMap, loadingSkeleton: false })
                } else {
                    this.setState({ featureMap: oldFeaturesList, loadingSkeleton: false })
                    ErrorAlert({ description: err.message })
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                this.setState({ featureMap: oldFeaturesList, loadingSkeleton: false })
                console.log("/getBusinessFeatures err", error, resp);
                ErrorAlert({ description: error.message })
            }
        });
    }

    resetToDefault = (record, heading) => {
        var currentRow = record;
        this.setState({ featureName: currentRow.name })
        var { BusinessUniqueKey, UserInfo } = this.props.aionStore
        var { Email } = UserInfo;

        if (currentRow) {
            var body = {
                FeatureName: currentRow.name,
                BusinessId: BusinessUniqueKey,
                UserEmail: Email,
                Product: heading,
                Resource: currentRow.resource
            }
            apiPOSTReq(`${environment.uamBaseUrl}/aion/system/resetToDefault`, {}, body, (err, resp) => {
                try {
                    if (err) throw Error(err);
                    const data = resp || {};
                    if (data.result) {
                        this.setState({
                            isModalVisible: false,
                            currentRow: null,
                            editableFeatureValue: "",
                            featureName: ""
                        }, () => this.fetchBusinessFeatures());
                    } else {
                        this.setState({ 
                            currentRow: null,
                            editableFeatureValue: "",
                            featureName: "" 
                        })
                        ErrorAlert({ description: data.responseMessage || "Sorry we had trouble processing your request. Please try again later" })
                        throw Error(data.responseMessage || data.error);
                    }
                } catch (error) {
                    console.log("/getBusiness err", error, resp);
                }
            });
        }
    }

    handleOpenModal = (row, heading) => {
        var body = {
            FeatureName: row.name,
            Product: heading,
            Resource: row.resource
        }

        apiPOSTReq(`${environment.uamBaseUrl}/aion/system/getFeatureInfo`, {}, body, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp || {};
                if (data.result) {
                    this.setState({
                        isModalVisible: true,
                        currentRow: row,
                        heading: heading,
                        editableFeatureValue: row.featureValue,
                        notes:""
                    });
                } else {
                    ErrorAlert({ description: data.responseMessage || "Sorry we had trouble processing your request. Please try again later" })
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                console.log("/getFeatureInfo err", error, resp);
            }
        });

    };
    
    handleModalOk = () => {
        const { currentRow, editableFeatureValue, heading, notes } = this.state;
        var { BusinessUniqueKey, UserInfo } = this.props.aionStore
        var { Email } = UserInfo;
        if (currentRow) {

            var body = {
                FeatureName: currentRow.name,
                FeatureValue: editableFeatureValue,
                UpdateCustom: true,
                BusinessIdList: [
                    BusinessUniqueKey
                ],
                UserEmail: Email,
                Notes: notes,
                Product: heading,
                Resource: currentRow.resource
            }

            apiPOSTReq(`${environment.uamBaseUrl}/aion/system/updateFeatureContainer`, {}, body, (err, resp) => {
                try {
                    if (err) throw Error(err);
                    const data = resp || {};
                    if (data.result) {
                        this.setState({
                            isModalVisible: false,
                            currentRow: null,
                            editableFeatureValue: "",
                            heading:"",
                            notes:""
                        }, () => this.fetchBusinessFeatures());
                    } else {
                        throw Error(data.responseMessage || data.error);
                    }
                } catch (error) {
                    console.log("/getBusiness err", error, resp);
                }
            });
        }
    };
    
    handleModalCancel = () => {
        this.setState({
          isModalVisible: false,
          currentRow: null,
          editableFeatureValue: ""
        });
    };
    
    handleFeatureValueChange = (e) => {
        const { value } = e.target;

        // Regex for numeric input, allowing decimals like "12", "12.34", or even ".5"
        const numericPattern = /^(?:\d+\.?\d*|\.\d*)$/;

        if (value === "") {
            this.setState({ editableFeatureValue: "0", errorField: "", errorMessage: "" });
        } else if (numericPattern.test(value)) {
            // Strip leading zeros unless it's like "0.5"
            let newValue = value.replace(/^0+(?=\d)/, '');
            this.setState({ editableFeatureValue: newValue, errorField: "", errorMessage: "" });
        } else {
            this.setState({ errorField: "featureValue", errorMessage: "Please enter a valid number." });
        }
    };

    handleSelect = (value, option) => {
        if(value === "On"){
            this.setState({ editableFeatureValue: "Y" })
        }
        else{
            this.setState({ editableFeatureValue: "N" })
        }
    }

    handleSearchChange = (e) => {
        this.setState({ [e.target.id]: e.target.value }, () => this.fetchBusinessFeatures())
    }

    handleNotesChange = (e) => {
        this.setState({ [e.target.id]: e.target.value })
    }

    renderTableRows = (data) => {
        const rows = [];

        Object.keys(data).forEach((resource) => {
            Object.keys(data[resource]).forEach((name) => {
                const featureValues = data[resource][name];
    
                featureValues.forEach((featureValue, index) => {
                rows.push({
                    key: `${resource}-${name}-${index}`,
                    resource: resource,
                    name: name,
                    featureValue: featureValue,
                });
                });
            });
        });
    
        return rows;
    };

    renderTable = (heading, data) => {
        const antIcon = <LoadingOutlined style={{ fontSize: 12 }} spin />;

        const columns = [
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
                align: 'left',
                width: "30%",
            },
            {
                title: "Resource",
                dataIndex: "resource",
                key: "resource",
                align: 'left',
                width: "20%",
            },
            {
                title: "Feature Value",
                dataIndex: "featureValue",
                key: "featureValue",
                align: 'left',
                width: "20%",
                render: (text) => (text === "Y" ? "On" : text === "N" ? "Off" : text),
            },
            {
                title: "Action",
                key: "action",
                align: 'center',
                width: "15%",
                render: (text,record) =>
                    (
                        <Flex center style={{ whiteSpace: 'nowrap' }}>
                            <a onClick={() =>  this.handleOpenModal(record, heading)}>Edit</a>
                        </Flex>
                    )
            },
            {
                title: "Reset",
                key: "reset",
                align: 'center',
                width: "15%",
                render: (text,record) =>
                    (
                        <Flex center style={{ whiteSpace: 'nowrap' }}>
                            <a onClick={() => this.resetToDefault(record, heading)} >Reset to default</a>
                            {record.name === this.state.featureName
                                ? <Spin indicator={antIcon} style={{ marginRight: "10px" }} />
                                :
                                <></>
                            }
                        </Flex>
                    )
            },
        ];
    
        const rows = this.renderTableRows(data);
    
        return (
            <div key={heading} style={{marginTop: 20}}>
                <TableView
                    id="heading"
                    titleText={heading}
                    columns={columns} 
                    dataSource={rows}
                    tableLayout='auto'
                    rowKey='name'
                    // pagination={pagination}
                    // onChange={this.handleTableChange}
                    // loading={loading}
                />
            </div>
        )
    };


    render() {
        const { featureMap, isModalVisible, currentRow, editableFeatureValue, searchTerm, notes, errorField, errorMessage, loadingSkeleton } = this.state;

        if (!featureMap) {
            return (
                <FlexColumn className='main-padding'>
                    <Skeleton active title={true} paragraph={{ rows: 3 }} /> 
                </FlexColumn>
            )
        }

        const reorderedFeatures = ["BusinessBanking", "Receivables", "Payables", "ARCredit", "AionApplications", "Bookkeeping", "AionApi"];

        const orderedKeys = reorderedFeatures
        .filter((key) => Object.keys(featureMap).includes(key))
        .concat(Object.keys(featureMap).filter((key) => !reorderedFeatures.includes(key)));
      
        const statuses = ["On", "Off"]
        const ignoreFields = ["Virtual Debit Card Issuance Limit", "Physical Debit Card Issuance Limit", "Recipients", "BatchUploadLimit", "Number of Accounts", 
            "Number of Products and Services / SKUs", "Number of Customers", "Number of Invoices", "Bill Payment - Number of Vendors", "Contractor Payroll - Number of Contractors",
            "Invoice Management - Invoice Templates", "Contractor Payroll - Paygroups", "InvoicePaymentPercent"]

        return (
            <>
                <FlexColumn className='main-padding'>

                    <PageHeader
                        titleText="Features"
                        desc="List of all your features"
                    />

                    <LabeledInput
                        id="searchTerm"
                        nomargin
                        width='400px'
                        placeholder="Search by Name"
                        prefixIcon={<img width='12px' height='12px' src={Search} />}
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                    />

                    <Skeleton loading={loadingSkeleton} active title={true} paragraph={{ rows: 3 }}>
                    {
                        featureMap && 
                        <div>
                            {orderedKeys.map((heading) => {
                                return this.renderTable(heading, featureMap[heading]);
                            })}
                        </div>
                    }
                    </Skeleton>
                    
                   
                    
                    <Modal
                        title="Edit Feature Value"
                        visible={isModalVisible}
                        onOk={this.handleModalOk}
                        onCancel={this.handleModalCancel}
                    >
                        {currentRow && (
                            <div>
                                <Flex between style={{ marginBottom: "20px" }}>
                                    <LabeledInput
                                        id="featureName"
                                        nomargin
                                        label='Feature Name'
                                        type='read-only'
                                        value={currentRow.name}
                                        noAsterisk
                                        // onChange={this.handleFeatureValueChange}
                                    />
                                </Flex>
                                <Flex between style={{ marginBottom: "20px" }}>
                                    <LabeledInput
                                        id="featureResource"
                                        nomargin
                                        label='Feature Resource'
                                        type='read-only'
                                        value={currentRow.resource}
                                        noAsterisk
                                        // onChange={this.handleFeatureValueChange}
                                    />
                                </Flex>
                               
                                <Flex between style={{ marginBottom: "20px" }}>
                                    {
                                        editableFeatureValue && ["Y", "N"].includes(editableFeatureValue) ?
                                        <LabeledInput
                                            id="featureValue"
                                            nomargin
                                            label='Feature Value'
                                            type="select"
                                            value={editableFeatureValue && editableFeatureValue === "Y" ? "On" : editableFeatureValue === "N" ? "Off" : editableFeatureValue}
                                            placeholder="Select a Status"
                                            onChange={this.handleSelect}
                                        >
                                            {
                                                statuses.map(
                                                    status => {
                                                        return <Select id="featureStatus" value={status}>{status}</Select>
                                                    }
                                                )
                                            }
                                        </LabeledInput>
                                        :
                                        /^\d+$/.test(editableFeatureValue) && !ignoreFields.includes(currentRow.name) ? 
                                        <LabeledInput
                                            id="featureValue"
                                            nomargin
                                            label='Feature Value'
                                            placeholder="Enter value"
                                            prefix="$"
                                            value={editableFeatureValue}
                                            onChange={this.handleFeatureValueChange}
                                            error={errorField == "featureValue"}
                                            errorMessage={errorMessage}
                                        /> : 
                                        <LabeledInput
                                            id="featureValue"
                                            nomargin
                                            label='Feature Value'
                                            placeholder="Enter value"
                                            value={editableFeatureValue}
                                            onChange={this.handleFeatureValueChange}
                                        />
                                        
                                    }
                                </Flex>
                                <Flex between style={{ marginBottom: "20px" }}>
                                    <LabeledInput
                                        id="notes"
                                        nomargin
                                        label='Notes'
                                        placeholder="Enter JIRA ticker number"
                                        noAsterisk
                                        optional
                                        onChange={this.handleNotesChange}
                                        value={notes}
                                    />
                                </Flex>
                                
                            </div>
                        )}
                    </Modal>

                </FlexColumn>
            </>    
        );
    }
}



function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        bankingStore: state.bankingAppReducer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(Index));